import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';

function LevelSelector({
  selectedLevel,
  setSelectedLevel,
}: {
  selectedLevel: string;
  setSelectedLevel: (level: string) => void;
}) {
  return (
    <Select
      value={selectedLevel}
      onValueChange={(level: string) => {
        setSelectedLevel(level);
      }}
    >
      <SelectTrigger className="min-w-[10rem] lg:min-w-[15rem] bg-white text-black">
        <SelectValue placeholder="Early In The Major" />
      </SelectTrigger>
      <SelectContent className="bg-white text-black">
        <SelectGroup>
          <SelectLabel>Stages/Levels</SelectLabel>
          <SelectItem className="capitalize" value="early">
            Early In The Major
          </SelectItem>
          <SelectItem className="capitalize" value="mid">
            Mid-Major
          </SelectItem>
          <SelectItem className="capitalize" value="late">
            Late In The Major
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}

export default LevelSelector;
